import { render, staticRenderFns } from "./OpenClaimModal.vue?vue&type=template&id=5745487b&scoped=true&"
import script from "./OpenClaimModal.vue?vue&type=script&lang=ts&"
export * from "./OpenClaimModal.vue?vue&type=script&lang=ts&"
import style0 from "./OpenClaimModal.vue?vue&type=style&index=0&id=5745487b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745487b",
  null
  
)

export default component.exports